import {Injectable} from '@angular/core';
import {
  CustomerActivePenetrationModel, CustomerBaseTrend, CustomerCardReleaseModel, CustomerOverviewCard, CustomerOverviewSerie,
  CustomerRevenueScontriniModel
} from '../../models/customer-campaign.model';
import {HttpClientService} from '../httpClient/httpclient.service';
import {DatePipe} from '@angular/common';
import {CustomerBaseTreeNode} from '../../models/customer.model';
import {SearchToolbarModel} from '../../modules/UIKit/components/searchToolBar/search-toolbar.model';

@Injectable()
export class CustomerCampaignService {



  base_url = 'koncentro-analytics'

  customer_trends: CustomerBaseTrend;
  /**
   * @deprecated see getTrends
   */
  customer_trends_v0; //retro compatibilità chiamata indiana

  customer_trend_revenue_scontrini: CustomerRevenueScontriniModel[];
  customer_trend_active_penetration: CustomerActivePenetrationModel[];
  customer_trend_card_release: CustomerCardReleaseModel[];

  base_tree: CustomerBaseTreeNode;
  customer_value_overview_cards: CustomerOverviewCard[];
  customer_value_graph: CustomerOverviewSerie[];

  constructor(private h: HttpClientService,
              private datePipe: DatePipe) {

  }

  parseRevenueScontrini(rsList) {
    rsList.forEach(rs => {
      rs['data_inizio'] = new Date(rs['data_inizio'])
      rs['data_fine'] = new Date(rs['data_fine'])
    })
  }


  getShoppingHabitsTrend(clusters: any) {
    return this.h.post('/koncentro-analytics/customers/shopping_habits_trend', clusters)
      .map(res => {
        return res;
      });
  }

  getValues(searchObject) {
    return this.h.post('/koncentro-analytics/customers/values', searchObject)
      .map(res => {
        return res;
      })
  }

  getTrendRevenueScontrini(filter: SearchToolbarModel) {
    return this.h.post(`/${this.base_url}/customers/trends_revenue_scontrini`, {
      date_from: this.datePipe.transform(filter.elapsed_start, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(filter.elapsed_end, 'yyyy-MM-dd'),
      group_type_code: filter.group_type_code,
      groups: filter.group_type != null ? filter.groups : [],
      stores: filter.stores != null ? filter.stores : [],
      loyalty: filter.card_mode
    })
      .map(res => {
        this.customer_trend_revenue_scontrini = res;
      })
  }

  getTrendCustomerPenetration(filter: SearchToolbarModel) {
    return this.h.post(`/${this.base_url}/customers/trends_customer_penetration`, {
      date_from: this.datePipe.transform(filter.elapsed_start, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(filter.elapsed_end, 'yyyy-MM-dd'),
      group_type_code: filter.group_type_code,
      groups: filter.group_type != null ? filter.groups : [],
      stores: filter.stores != null ? filter.stores : []
    })
      .map(res => {
        this.customer_trend_active_penetration = res;
      })
  }

  getTrendCardRelease(filter: SearchToolbarModel) {
    return this.h.post(`/${this.base_url}/customers/trends_card_release`, {
      date_from: this.datePipe.transform(filter.elapsed_start, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(filter.elapsed_end, 'yyyy-MM-dd'),
      group_type_code: filter.group_type_code,
      groups: filter.group_type != null ? filter.groups : [],
      stores: filter.stores != null ? filter.stores : []
    })
      .map(res => {
        this.customer_trend_card_release = res;
      })
  }

  getTrendRevenueAnalysis(mode, filter: SearchToolbarModel) {
    return this.h.post(`/${this.base_url}/customers/trends_revenue_analysis`, {
      mode: mode,
      date_from: this.datePipe.transform(filter.elapsed_start, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(filter.elapsed_end, 'yyyy-MM-dd'),
      group_type_code: filter.group_type_code,
      groups: filter.group_type != null ? filter.groups : [],
      stores: filter.stores != null ? filter.stores : [],
      loyalty: filter.card_mode
    })
      .map(res => {
        this.parseRevenueScontrini(res['revenue_scontrini_list'])
        this.customer_trend_revenue_scontrini = res['revenue_scontrini_list']
        this.customer_trend_active_penetration = res['customer_penetration_list']
        this.customer_trend_card_release = res['card_release_list']
      })
  }


  /**
   * @deprecated use instead getTrendRevenueScontrini
   */
  getTrends(searchObject) {

    return this.h.post('/koncentro-analytics/customers/trends', searchObject)
      .map(res => {
        this.customer_trends = res;
        this.customer_trends_v0 = {
          currentRevenueModel: [],
          previousRevenueModel: [],
          currentActiveCustomerModel: [],
          previousActiveCustomerModel: [],
          currentCardPenitrationModel: [],
          previousCardPenitrationModel: [],
          currentCardReleaseModel: [],
          previousCardReleaseModel: [],
          startDateRange: {},
          endDateRange: this.customer_trends.last_date,
          cardReleaseStartDateRange: {},
          cardReleaseEndDateRange: this.customer_trends.last_date

        }
        this.customer_trends.card_release.forEach(cr => {
          this.customer_trends_v0.currentCardReleaseModel.push({
            currentYear: cr.year,
            currentBusMonth: cr.bus_month,
            currentCardRelease: cr.current_card_release,
            currentTimePeriod: cr.year.toString().concat('-').concat(cr.bus_month.toString())
          })
          this.customer_trends_v0.previousCardReleaseModel.push({
            previousYear: cr.year,
            previousBusMonth: cr.bus_month,
            previousCardRelease: cr.previous_card_release,
            previousTimePeriod: cr.year.toString().concat('-').concat(cr.bus_month.toString())
          })
        })
        this.customer_trends.trends.forEach(ct => {
          this.customer_trends_v0.currentRevenueModel.push({
            currentYear: ct.year,
            currentBusMonth: ct.bus_month,
            currentRevenue: ct.current_revenue,
            currentTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())
          })

          this.customer_trends_v0.previousRevenueModel.push({
            previousYear: ct.year,
            previousBusMonth: ct.bus_month,
            previousRevenue: ct.previous_revenue,
            previousTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())
          })

          this.customer_trends_v0.currentActiveCustomerModel.push({
            currentYear: ct.year,
            currentBusMonth: ct.bus_month,
            currentActiveCustomers: ct.current_active_customers,
            currentTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())

          })

          this.customer_trends_v0.previousActiveCustomerModel.push({
            previousYear: ct.year,
            previousBusMonth: ct.bus_month,
            previousActiveCustomers: ct.previous_active_customers,
            previousTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())

          })

          this.customer_trends_v0.currentCardPenitrationModel.push({
            currentYear: ct.year,
            currentBusMonth: ct.bus_month,
            currentCardPenitration: ct.current_card_penitration,
            currentTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())

          })

          this.customer_trends_v0.previousCardPenitrationModel.push({
            previousYear: ct.year,
            previousBusMonth: ct.bus_month,
            previousCardPenitration: ct.previous_card_penitration,
            previousTimePeriod: ct.year.toString().concat('-').concat(ct.bus_month.toString())

          })

        })
        console.log('customer_trends_v0', this.customer_trends_v0)
        return this.customer_trends_v0;

      });
  }

  getTopCategories(date_from: Date, date_to: Date, clusters) {
    return this.h.post('/koncentro-analytics/customers/top_categories', {
      date_from: this.datePipe.transform(date_from, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(date_to, 'yyyy-MM-dd'),
      clusters: clusters
    })
      .map(res => {
        return res;
      })

  }

  getCustomerBaseTree(date_from: Date, date_to: Date, group_type_code, groups, area, stores) {
    return this.h.post('/koncentro-analytics/customers/base_tree', {
      date_from: this.datePipe.transform(date_from, 'yyyy-MM-dd'),
      date_to: this.datePipe.transform(date_to, 'yyyy-MM-dd'),
      area: area,
      group_type_code: group_type_code,
      groups: groups,
      stores: stores
    })
      .map(res => {
        return this.base_tree = res;
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-campaign.service.ts